import type { IExtra } from "@app/common/types";

import { getShortId } from "../ids/generateIds";

export const getSelectedExtras = (extras: IExtra[], extraShortIds: string[]) =>
    (extras || []).filter((e) => extraShortIds.includes(getShortId(e.id) || ""));
